import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Offcanvas  from "react-bootstrap/Offcanvas";

function AssignTarget(props) {
    const { handleSubmit, control, register, formState, watch, setValue } = useForm();
    const watchYear = watch("year");
    const [thisYearTarget, setThisYearTarget] = React.useState({});
 
  const onSubmit = async (data) => {
    try {
      let res = await API({
        url: "/birdview/assignTarget",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: props.actionId.id,
          sales_person_id:props.sales_person_id,
          ...data
        },
      });
      if (res.code === 200) {
        Toast("success", "Target Assigned Successfully");
        props.setShow(false);
      }
    } catch (error) { 
      console.error(error);
    }
  };

  const fetchTargets = async () => {
    try {
      let res = await API({
        url: "/birdview/getTarget",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: props.actionId.id,
          year: watchYear,
          sales_person_id: props.sales_person_id
        }
      });
      if (res.code === 200) {
        setThisYearTarget(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchTargets();
  }, [watchYear]);

  useEffect(() =>{
    if(thisYearTarget.length > 0){
      Array.from({ length: 12 }, (_, index) => {
        const month = new Date(0, index).toLocaleString('en', { month: 'long' });
        setValue(month.toLowerCase(), thisYearTarget[0][month.toLowerCase()]);
    })
  }}, [thisYearTarget])

  return (
    <>
      <Offcanvas
        show={props.show}
        onHide ={()=>{props.setShow(false)}}
       backdrop="static"
       placement="end"
        // responsive="md"
      >
        
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Assign Target</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      {/* Year Picker */}
      <div>
        <label className="block font-semibold mb-2">Select Year:</label>
        <Controller
          control={control}
          name="year"
          rules={{ required: true }}
          defaultValue={new Date()}
          render={({ field }) => (
            <DatePicker
              {...field}
              selected={field.value}
              onChange={(date) => field.onChange(date)}
              showYearPicker
              dateFormat="yyyy"
              className="border px-4 py-2 rounded"
            />
          )}
        />
      </div>

      {/* Month Inputs */}
      <div>
        <label className="block font-semibold mb-2">Monthly Data:</label>
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
          {Array.from({ length: 12 }, (_, index) => {
            const month = new Date(0, index).toLocaleString('en', { month: 'long' });
            return (
              <div key={month} className="flex flex-col">
                <label className="mb-1">{month}</label>
                <input
                  {...register(month.toLowerCase(), {required: 'This field is required'})}
                  type="number"
                  placeholder={`Enter data for ${month}`}
                  className="border px-2 py-1 rounded"
                />
                {formState?.errors[month.toLowerCase()] && (
                  <span className="text-red-500">
                    {formState?.errors[month.toLowerCase()]?.message}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded">
        Submit
      </button>
    </form>
    </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AssignTarget;
